import { render, staticRenderFns } from "./UserReports.vue?vue&type=template&id=99d768c8&scoped=true"
import script from "./UserReports.vue?vue&type=script&lang=js"
export * from "./UserReports.vue?vue&type=script&lang=js"
import style0 from "./UserReports.vue?vue&type=style&index=0&id=99d768c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d768c8",
  null
  
)

export default component.exports